export enum Platform {
    Kiwi = 'kiwi',
    Legacy = 'legacy',
}
